import React, { useContext } from 'react';
import Text from '../Text/Text';
import { ConfigContext } from '../../context/Config';
import moment from 'moment';
import Avatar from '../Avatar/Avatar';
import Wrapper from '../Wrapper';
import './NewsListItem.less';
import { IconLink } from '../Icons';

export type NewsListItemPropsType = {
  title: string;
  description?: string;
  author?: string;
  avatar?: string;
  link?: string;
  date?: string;
};

const NewsListItem: React.FC<NewsListItemPropsType> = ({
  title,
  description,
  avatar,
  link,
  author,
  date,
}) => {
  const { translate } = useContext(ConfigContext);

  return (
    <div className="t-news-list-item">
      <Wrapper mr={1}>
        <Avatar name={title} src={avatar} />
      </Wrapper>
      <div className="t-news-list-item-info-wrapper">
        <Wrapper>
          <Text bold rows={1}>
            {title}
          </Text>
          <Text level={2} rows={2}>
            {description}
          </Text>
          {!!author && (
            <Text rows={1} level={3} textColor="dark-50">
              {translate('news.author')}:{` ${author}`}
            </Text>
          )}
          {!!date && (
            <Text rows={1} level={3} textColor="dark-50">
              {translate('news.date')}:{` ${moment(date).format('LL')}`}
            </Text>
          )}
        </Wrapper>
        {!!link && (
          <Wrapper ml={1}>
            <a target="_blank" href={link}>
              <IconLink size="xl" />
            </a>
          </Wrapper>
        )}
      </div>
    </div>
  );
};

export default NewsListItem;
